$(document).ready(function () {
    if(window.location.href.indexOf("store") > -1) {
      $( ".moveBanner" ).one().insertBefore( ".main" );
      // $('.moveBanner').flickity({
      //   wrapAround: true
      // });
    }
    setTimeout(function(){
    $('#page_banner_slider').slick({
      infinite: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  },100);
});
